export function isRedirectFromStripe(location: string): boolean {
  const query = new URLSearchParams(location);

  const clientSecrets = query.getAll('payment_intent_client_secret');
  const redirectStatuses = query.getAll('redirect_status');

  return clientSecrets.length > 0 && redirectStatuses.length > 0;
}

export type StripeOCSRedirectStatus = 'success' | 'canceled';

export function isRedirectFromStripeOCS(location: string): boolean {
  return getStripeOCSRedirectStatus(location) !== null;
}

export function getStripeOCSRedirectStatus(location: string): StripeOCSRedirectStatus | null {
  const query = new URLSearchParams(location);

  if (query.get('success') === 'true') {
    return 'success';
  }

  if (query.get('canceled') === 'true') {
    return 'canceled';
  }

  return null;
}

export function stripQueryParams(url: string): string {
  const urlObj = new URL(url);
  urlObj.search = '';
  return urlObj.toString();
}
